import { Button, Col, Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { authFeatureConstants, CANCELLATION_STATUS_ID, GUTTOR_SPACE, RPA_PAYER_NOT_CONFIGURED_ERR } from '../../../../shared/constants/commonConstants';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { useHistory, useLocation } from 'react-router';
import { base64UrlDecode, base64UrlEncode, canActivate, centeredNotification } from '../../../../utils/utility';
import { actions, ctaActionNames, NON_CONFIGURED_PAYERS_BLOCK_POST_PRE_AUTH,
  USER_ACTIONS } from '../../../../shared/constants/crmConstants';
import { getDateDurationInHours } from '../../../../utils/dateTimeUtils';
import SuccessModal from '../newAdmission/panels/SuccessModal/SuccessModal';
import { customGTMEvent, getIsPageNameNewAdmission, isReconsiderEnabled } from '../service/crmUtils';
import { resubmitClaim, setInpatientReconsiderClicked, setIsDeleteModal } from '../../../../store/actions/claimDetailsAction';
import useGetPasswordExpireNotification from '../../../../shared/hooks/useGetPasswordExpireNotification';
import ConsentModal from '../newAdmission/panels/ConsentModal/ConsentModal';
import { NewAdmissionState } from '../../../../store/models/newAdmissionModel';
import { setIsEasyDischargeCase } from '../../../../store/actions/inPatientAction';
import { ApplicationDetailModel } from '../../../../store/models/applicationDetailModel';
import { paymentAcknowledge, setIsDischargeCase } from '../../../../store/actions/newAdmissionAction';
import { setIsShowingDoADoDEnhancementModal } from '../../../../store/actions/newAdmissionAction';
import { MailboxType } from '../../../../store/models/mailBoxModel';
import DeleteClaimModalNew from './DeleteClaimModalNew';
import ReconsiderModal from '../../../../shared/components/modal/ReconsiderModal';
import { isEmpty } from 'lodash';
import { setDeeplinkDto } from '../../../../store/actions/authAction';
import { DeeplinkDto } from '../../../../store/models/authModel';
import { setAutomatedNewAdmission } from '../../../../store/actions/hospitalAction';
import { RedirectActionConfig, StageActionConfig } from '../../../../shared/interfaces/newAdmissionInterface';

export const RightActionsClaimDetailHeader = (props: any): ReactElement => {
  const { form, isDeeplinkProcessed } = props;
  const { toggleClick } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { claimDetails, isInpatientReconsiderAction, isDeleteModal, claimDetails: { isEnhance, isCancelable, isCashlessSubmission, isQuery,
    isFreeEditable, isReconsider, isEasyDischarge, isEasyDischargeQuery, isPaymentAcknowledged, isDischargeCTA, isDischargeContestCTA,
    isArtemis } } =
    useSelector((state: RootState): any => state.admissionDetails);
  const { payerList: { payer, allPayers = [], formControlConfig } } = useSelector((state: RootState): RootState => state || {});
  const { hospitalConfiguration: emailConfiguration = {} as any } = useSelector((state: RootState): MailboxType => state?.mailBox || {});
  const { payerNotConfig, isPreAuthView, isClaimDetailApiLoaded }
    = useSelector((state: RootState): any => state.selectedInPatientDetail);
  const getNotification = useGetPasswordExpireNotification();
  const appdetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
  const { passwordExpire } = emailConfiguration;

  const [canReSubmit, setCanResubmit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPaymentAcknowledgementSuccess, setIsPaymentAcknowledgementSuccess] = useState(false);
  const isEasyDischargeEnabled = appdetails.getIsEasyDischargeEnabled();
  const [reconsiderModal, setReconsiderModal] = useState(false);
  const isPreAuthClaimViewEnabled = appdetails?.getIsPreAuthClaimViewEnabled();
  const cancelActionCTA = JSON.parse(payer?.actionProperties || '{}')?.[CANCELLATION_STATUS_ID]?.CTAName;
  const history = useHistory();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const payerConfigValues = Object.values(formControlConfig);
  const ARTEMIS_PAYER = payerConfigValues.some(({type}: any): boolean => type === 'ARTEMIS');
  const reconsiderBtnValidation = payerConfigValues?.some((config: any): any => Boolean(config?.reconsiderBtnValidation));
  const isOrionIntegrationEnabledProvider = appdetails.getIsOrionIntegrationEnabled();
  const disableReconsider = ARTEMIS_PAYER && isOrionIntegrationEnabledProvider && isArtemis;
  const showReconsiderModal = reconsiderModal || isInpatientReconsiderAction;
  const { deeplinkDto } = useSelector((state: RootState): any => state.auth);
  const isClaimInQuery = (isQuery || isEasyDischargeQuery);

  useEffect((): any => {
    // allow re-submission of claim for CMHT incase claim no. is not generated within 4hrs
    const { claimFlowData, productCode, payerClaimNo, payerRetryCounts } = claimDetails || {};
    if (claimFlowData?.length) { // handing null check
      const { createdDate, status } = claimFlowData?.[0] || {};
      const duration = getDateDurationInHours(createdDate);
      const canUserReSubmit = !payerClaimNo && productCode === 'CMHT' && Math.floor(duration) >= 4 &&
        claimFlowData?.length === 1 && status === 'Pre Auth Initiated' && !payerRetryCounts;
      setCanResubmit(canUserReSubmit);
    }
  }, [isClaimDetailApiLoaded]);

  const onError = (errors: any): void => {
    centeredNotification(errors);
    setIsSubmitting(false);
  };

  const onSuccess = (): any => {
    setIsModalVisible(true);
    setIsSubmitting(false);
  };

  const onPaymentAcknowledgeSuccess = (): any => {
    setIsPaymentAcknowledgementSuccess(true);
  };

  const onResubmit = async (): Promise<void> => {
    const { claimBillDetails } = claimDetails;
    const { billHospActionFlowId } = claimBillDetails[0] || {};
    const payload = {
      hospActionFlowIdList: [billHospActionFlowId],
    };
    setIsSubmitting(true);

    dispatch(resubmitClaim(payload, onSuccess, onError));
  };

  const onEditClick = (): any => {
    history.push(`${pathname}/edit/${base64UrlEncode(actions.EDIT)}`);
  };
  const handleReConsiderModal = (e: any): any => {
    if (e.target.textContent === 'Proceed') {
      history.push(`${pathname}/reconsider`);
      setReconsiderModal(false);
      dispatch(setInpatientReconsiderClicked(false));
    } else {
      const path = pathname.split('/');
      const decrypted = base64UrlDecode(path[path.length - 1]).split('/');
      decrypted[decrypted.length - 1] = 'false';
      const claimDetailUrl = `/claims/in-patient/detail/${base64UrlEncode(decrypted.join('/'))}`;
      history.push(claimDetailUrl);
      setReconsiderModal(false);
      dispatch(setInpatientReconsiderClicked(false));
    }
  };
  const acknowledgePayment = (): any => {
    dispatch(paymentAcknowledge(claimDetails, onPaymentAcknowledgeSuccess, onError));
  };

  // Configuration object for stage actions
  const stageActions: Record<string, StageActionConfig> = {
    ENHANCE: {
      route: `${pathname}/edit`,
      event: 'Click on Enhance',
    },
    DISCHARGE: {
      route: `${pathname}/discharge`,
      event: 'Click on Discharge CTA',
    },
    QUERY: {
      route: `${pathname}/edit`,
      event: 'Click on Query Response',
    },
    RECONSIDER: {
      customAction: (): void => {
        if (payer?.isReconsiderationAlertEnabled) {
          setReconsiderModal(true);
        } else {
          history.push(`${pathname}/reconsider`);
        }
      },
    },
    CANCEL: {
      route: `${pathname}/cancel/${base64UrlEncode(actions.CANCEL)}`,
      event: 'Click on Cancel',
      preAction: (): any => dispatch(setIsDeleteModal(true)),
    },
    SETTLEMENT: {
      route: `${pathname}/edit/${base64UrlEncode(actions.CASHLESSSUMBIT)}`,
      event: 'Click on Initiate Settlement',
    },
    RESUBMIT: {
      customAction: onResubmit,
    },
    EASYDISCHARGEINITIATED: {
      route: `${pathname}/edit`,
      event: 'Click on Early Discharge',
    },
    EASYDISCHARGEQUERYREPLIED: {
      route: `${pathname}/edit`,
    },
    FREE_EDIT: {
      customAction: onEditClick,
    },
    Payment_Acknowledged: {
      customAction: acknowledgePayment,
    },
    VIEWCLAIM: {
      route: `${pathname}`,
    },
  };

  const checkForPasswordExpiry = (stage: string): any => {
    const eventData = {
      payerName: claimDetails?.payerName,
      currentStatus: claimDetails?.statusName,
      insurerName: claimDetails?.insurerName,
      claimNumber: claimDetails?.payerClaimNo,
    };
    if (isEmpty(allPayers)) {
      centeredNotification(NON_CONFIGURED_PAYERS_BLOCK_POST_PRE_AUTH, 'info');
      return;
    }

    if (passwordExpire && claimDetails?.payerType === 'MultiPayer') {
      centeredNotification('password expired', 'error', getNotification);
      return;
    }

    if (payerNotConfig) {
      centeredNotification(RPA_PAYER_NOT_CONFIGURED_ERR);
      return;
    }

    // Execute stage action using configuration
    const stageConfig = stageActions[stage];
    if (stageConfig) {
      // Execute pre-action if exists
      stageConfig.preAction?.();

      // Execute custom action or navigate to route
      if (stageConfig.customAction) {
        stageConfig.customAction();
      } else if (stageConfig.route) {
        history.push(stageConfig.route);
      }

      // Track event if configured
      if (stageConfig.event) {
        customGTMEvent({
          ...eventData,
          event: stageConfig.event,
        });
      }
    }
  };
  const handleEnhanceOrQueryClick = (): void => {
    if (!isClaimInQuery) {
      dispatch(setIsShowingDoADoDEnhancementModal(true));
    }
    if (isQuery) {
      checkForPasswordExpiry('QUERY');
    } else {
      checkForPasswordExpiry('ENHANCE');
    }
  };

  const handleEasyDischargeClick = (): void => {
    dispatch(setIsEasyDischargeCase(true));
    checkForPasswordExpiry('EASYDISCHARGEINITIATED');
  };

  const handleDischargeClick = (): void => {
    dispatch(setIsShowingDoADoDEnhancementModal(true));
    dispatch(setIsDischargeCase(true));
    checkForPasswordExpiry('DISCHARGE');
  };

  // Configuration object for redirect actions
  const redirectActionConfig: Record<string, RedirectActionConfig> = {
    ENHANCE: {
      condition: (): boolean => isEnhance,
      handler: handleEnhanceOrQueryClick,
    },
    DISCHARGE: {
      condition: (): boolean => isDischargeCTA || isDischargeContestCTA,
      handler: handleDischargeClick,
    },
    QUERY: {
      condition: (): boolean => isClaimInQuery,
      handler: handleEnhanceOrQueryClick,
    },
    RECONSIDER: {
      condition: (): boolean => isReconsider && isReconsiderEnabled(claimDetails, reconsiderBtnValidation, disableReconsider),
      handler: (): void => checkForPasswordExpiry('RECONSIDER'),
    },
    CANCEL: {
      condition: (): boolean => isCancelable,
      handler: (): void => checkForPasswordExpiry('CANCEL'),
    },
    SETTLEMENT: {
      condition: (): boolean => isCashlessSubmission,
      handler: (): void => checkForPasswordExpiry('SETTLEMENT'),
    },
    EASYDISCHARGEINITIATED: {
      condition: (): boolean => isEasyDischargeEnabled && isEasyDischarge,
      handler: handleEasyDischargeClick,
    },
    VIEWCLAIM: {
      condition: (): boolean => true,
      handler: (): void => checkForPasswordExpiry('VIEWCLAIM'),
    },
  };

  const redirectToAction = (action: string): void => {
    const actionConfig = redirectActionConfig[action];
    if (actionConfig?.condition()) {
      actionConfig.handler();
    } else if (!actionConfig) {
      centeredNotification('Invalid Action', 'error');
    }

    dispatch(setAutomatedNewAdmission(false));
  };

  useEffect((): void => {
    if (!isEmpty(deeplinkDto) && !isEmpty(claimDetails) && isDeeplinkProcessed) {
      const userActionId = deeplinkDto?.deeplinkQueryParams?.userActionId;
      const userAction = USER_ACTIONS[userActionId];
      redirectToAction(userAction);
      dispatch(setDeeplinkDto({} as DeeplinkDto)); // Clear the deeplinkDto after processing
    }
  }, [deeplinkDto, claimDetails, isDeeplinkProcessed]);

  return (
    <React.Fragment>
      {canActivate(authFeatureConstants.EDIT_ADMISSION) && (
        <>
          <Row gutter={GUTTOR_SPACE}>
            {payer?.isClaimSubmissionDisabled ? (
              <Col md={24} className="text-right">
                <Button
                  type="primary"
                  onClick={(): void => {
                    window.open(
                      JSON.parse(payer.payerReDirectionDtails || '{}').link,
                      '_blank',
                    );
                  }}
                >
                  {JSON.parse(payer.payerReDirectionDtails || '{}').lable}
                </Button>
              </Col>
            ) : (
              <Col md={24} className="text-right">
                {isEnhance && (!isPreAuthClaimViewEnabled || isPreAuthView) ||
                  isQuery ||
                  (process.env.REACT_APP_IS_EASY_DISCHARGE === 'true' &&
                    isEasyDischargeEnabled &&
                    isEasyDischargeQuery) ? (
                  <Button
                    data-testid="enhance"
                    className="mr-10"
                    type="primary"
                    onClick={(): void => handleEnhanceOrQueryClick()}
                  >
                    {isClaimInQuery ? (
                      <p id="WA_QUERY_RESPONSE">{ctaActionNames.QUERY}</p>
                    ) : (
                      <p id="WA_ENHANCE">{ctaActionNames.ENHANCE}</p>
                    )}
                  </Button>
                ) : null}
                {/* 4074-ipp-reconsider-btn-star */}
                {isReconsider && isReconsiderEnabled(claimDetails, reconsiderBtnValidation, disableReconsider) ? (
                  <Button
                    data-testid="reconsider"
                    className="mr-10"
                    type="primary"
                    onClick={(): void => checkForPasswordExpiry('RECONSIDER')}
                  >
                    {ctaActionNames.RECONSIDER}
                  </Button>
                ) : null}
                {
                  process.env.REACT_APP_IS_EASY_DISCHARGE === 'true' &&
                  isEasyDischargeEnabled &&
                  isEasyDischarge && (!isPreAuthClaimViewEnabled || isPreAuthView) && (
                    <Button
                      type="primary"
                      className="mr-10"
                      onClick={(): void => handleEasyDischargeClick()}
                    >
                      {ctaActionNames.EARLYDISCHARGE}
                    </Button>
                  ) // change in CTA from 'Easy Discharge' to 'Early Discharge' (IPP-4803)
                  }
                  {isDischargeCTA && (!isPreAuthClaimViewEnabled || isPreAuthView) && (
                    <Button
                      data-testid="re-submit"
                      className={`mr-10 ${isPaymentAcknowledgementSuccess ? 'next-btn' : 'primary'}`}
                      type={isPaymentAcknowledgementSuccess ? undefined : 'primary'}
                      disabled={isPaymentAcknowledgementSuccess}
                      onClick={(): any => handleDischargeClick()}
                      loading={isSubmitting}
                    >
                      {ctaActionNames.DISCHARGE}
                    </Button>
                  )}
                  {isDischargeContestCTA && (
                    <Button
                      data-testid="re-submit"
                      className={`mr-10 ${isPaymentAcknowledgementSuccess ? 'next-btn' : 'primary'}`}
                      type={isPaymentAcknowledgementSuccess ? undefined : 'primary'}
                      disabled={isPaymentAcknowledgementSuccess}
                      onClick={(): void => handleDischargeClick()}
                      loading={isSubmitting}
                    >
                      {ctaActionNames.DISCHARGECONTEST}
                    </Button>
                  )}
                {isCancelable && (
                  <Button
                    data-testid="cancel"
                    className="mr-10"
                    type="primary"
                    onClick={(): void => checkForPasswordExpiry('CANCEL')}
                  >
                      {cancelActionCTA || ctaActionNames.CANCEL}
                  </Button>
                )}
                {isCashlessSubmission &&
                  <Button
                    type="primary"
                    data-testid="settlement"
                    className="mr-10"
                    onClick={(): void => {
                      checkForPasswordExpiry('SETTLEMENT');
                    }}
                  >
                    {ctaActionNames.SETTLEMENT}
                  </Button>
                }
                {canReSubmit && (
                  <Button
                    data-testid="re-submit"
                    className="mr-10"
                    type="primary"
                    onClick={(): any => checkForPasswordExpiry('RESUBMIT')}
                    loading={isSubmitting}
                  >
                    {ctaActionNames.RESUBMIT}
                  </Button>
                )}
                {isFreeEditable && (
                  <Button
                    data-testid="re-submit"
                    className="mr-10"
                    type="primary"
                    onClick={(): any => checkForPasswordExpiry('FREE_EDIT')}
                    loading={isSubmitting}
                  >
                    {ctaActionNames.EDIT}
                  </Button>
                )}
                {
                  isPaymentAcknowledged &&
                  <Button
                    data-testid="re-submit"
                    className={`mr-10 ${isPaymentAcknowledgementSuccess ? 'next-btn' : 'primary'}`}
                    type={isPaymentAcknowledgementSuccess ? undefined : 'primary'}
                    disabled={isPaymentAcknowledgementSuccess}
                    onClick={(): any => checkForPasswordExpiry('Payment_Acknowledged')}
                    loading={isSubmitting}
                  >
                    {ctaActionNames.PAYMENTACKNOWLEDGEMENT}
                  </Button>
                }
              </Col>
            )}
          </Row>
          <DeleteClaimModalNew
            isEnabled={isDeleteModal}
            setIsEnabled={setIsDeleteModal}
          />
          {toggleClick && isModalVisible && <ConsentModal />}
          <SuccessModal
            isResubmitted={true}
            isModalVisible={isModalVisible}
            setIsModalVisible={setIsModalVisible}
            form={form}
            isNew={getIsPageNameNewAdmission(pathname)}
          />
          {showReconsiderModal &&
            <ReconsiderModal reconsiderModal={showReconsiderModal} handleReConsiderModal={handleReConsiderModal} />
          }
        </>
      )}
    </React.Fragment>
  );
};
